import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

export function LanguageToggle({ variant = 'ghost', size = 'sm' }) {
    const { lang, toggle } = useLang();
    return (
        <Button variant={variant} size={size} onClick={toggle} data-testid='language-toggle' aria-label='Change language'>
            <Globe className='w-4 h-4 mr-1' />
            {lang === 'en' ? 'हिन्दी' : 'English'}
        </Button>
    );
}
export default LanguageToggle;
